<!-- 分享紀錄的列表模式：每個直屬下線一張卡片，有下線的點一下展開 -->
<template>
  <div class="org-list">
    <div v-for="root in treeData" :key="root.guid" class="org-list__card">
      <OrgListNodeItem :node="root" :query="q" />
    </div>
    <div v-if="!treeData.length" class="org-list__empty">{{ q ? "找不到符合的人" : "目前還沒有分享紀錄" }}</div>
  </div>
</template>

<script>
import OrgListNodeItem from "./OrgListNodeItem.vue";
import { buildOrgTree } from "./orgUtils";

export default {
  name: "OrgList",
  components: { OrgListNodeItem },
  props: {
    // 平面資料（含 guid / parentGuid）。搜尋過濾（含要不要保留上層、下層）由 ShareOrgDialog 做好才傳進來，這裡不再篩一次
    referrals: { type: Array, default: () => [] },
    searchQ: { type: String, default: "" },
  },
  computed: {
    q() {
      return (this.searchQ || "").trim();
    },
    treeData() {
      return buildOrgTree(this.referrals || []);
    },
  },
};
</script>

<style scoped>
.org-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 12px;
}

.org-list__card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.org-list__empty {
  padding: 48px 16px;
  text-align: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}
</style>
